import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  dropdown_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    direction: "ltr",
  },
  dropdown_icon: {
    // opacity: '0.75',
  },
  dropdown_label: {
    color: "#353535",
    letterSpacing: 0,
  },

  //------------------- standart wide bold --------------//
  standard_container: {
    margin: "10px 10px !important",
    minWidth: "0 !important",
  },

  wide_container: {
    margin: "0px 20px !important",
    minWidth: "0 !important",
  },
  wide_bold_container: {
    margin: "0px 20px !important",
    minWidth: "0 !important",
    fontWeight: "bold",
  },
  regular_icon: {
    color: "#353535",
    opacity: "0.75",
  },
  bold_icon: {
    color: "#00833E",
  },
  regular_label: {},
  bold_label: {
    fontWeight: "bold",
  },
  //------------------------------------------------------//
}));

export default useStyles;
